import type { RowData } from '@tanstack/react-table';
import type { Column } from '@tanstack/table-core';
import type { kkTableFeatures } from '../tableFeatures';
import { FilterSearch } from './FilterSearch';
import { ImmediateCheckboxFilterOptions } from './ImmediateCheckboxFilterOptions';
import { useImmediateCheckboxFilter } from './useImmediateCheckboxFilter';

interface ImmediateCheckboxFilterProps<TData extends RowData> {
  data: TData[];
  column: Column<typeof kkTableFeatures, TData, unknown> | undefined;
  filterValue: unknown;
  close: () => void;
  label: React.ReactNode;
}

export function ImmediateCheckboxFilter<TData extends RowData>({
  data,
  column,
  filterValue,
  close,
  label,
}: ImmediateCheckboxFilterProps<TData>) {
  const showSearch = column?.columnDef.meta?.showSearchInFilter ?? true;
  const { onSearchChange, ...optionsProps } = useImmediateCheckboxFilter({
    data,
    column,
    filterValue,
    showSearch,
  });

  return (
    <div className="py-1 *:not-first:mt-1">
      {showSearch ? (
        <FilterSearch
          column={column}
          close={close}
          inputClassName="w-full rounded border-2! border-neutral-10 bg-neutral-5 p-2 pl-10 kunde:pl-10"
          label={label}
          onChange={onSearchChange}
          value={optionsProps.search}
        />
      ) : null}
      <ImmediateCheckboxFilterOptions column={column} {...optionsProps} />
    </div>
  );
}
